import { useSelector } from 'react-redux';
import { userRoleNameSelector } from '../../../../redux/modules/user/selectors';
import { useIsFeatureEnabled } from '../../../feature-enablement/featureEnablement';

export const useDocumentCommentsFlags = () => {
  const isDocumentCommentsEnabled = useIsFeatureEnabled('document-comments');
  const userRole = useSelector(userRoleNameSelector);

  return {
    hasWriteAcess: userRole && userRole !== 'viewer',
    isDocumentCommentsEnabled,
  };
};
